import React, {Component} from 'react';
// import {connect} from '~/redux/connect';
import {getModelName, isDataModelValid, isDataModelLoading, getModelNameOrNull} from "~/stateGetter";
import {fetchModelConfigs} from '~/rx/modelConfigs'
import { connect } from '~/redux/connect';
import identify from "~/identify";
import limit from "~/data/limit";

class ModelDataManager extends Component {
    static propTypes  = {

    };

    static defaultProps = {
        children: null
    };

    isOutOfSync(prev) {
        if(this.props.invalid) { return false; }

        return !this.props.isDataModelValid && !this.props.isDataModelLoading;
    }

    componentDidUpdate(prev) {
        if(this.isOutOfSync()) {
            this.loadDataModel();
        }
    }

    // ToDo: limit?
    loadDataModel() {
        let { fetchModelConfigs } = this.props;

        return fetchModelConfigs([this.props.modelName]);
    }

    componentDidMount() {
        if(!this.isOutOfSync()) {
            return;
        }

        // limit(identify.MODELCONFIGS_REQUEST_GROUP, () => {
            return this.loadDataModel();
        // });
    }

    render() {
        return this.props.children;
    }
}

const RXModelDataManager = connect(
    (state, {modelId}) => {
        let modelName = getModelNameOrNull(state, modelId);
        // if(!modelName) {
        //     return {
        //         invalid: true
        //     }
        // }

        return {
            modelName,
            isDataModelValid: isDataModelValid(state, modelId),
            isDataModelLoading: isDataModelLoading(state, modelId),
        }
    },

    (dispatch, { modelId }) => {
        return {
            fetchModelConfigs: (modelNames) => dispatch(fetchModelConfigs(modelNames))
        }
    },

    ({ modelName, ...stateProps }, { fetchModelConfigs, ...dispatchProps }, ownProps) => {
        return {
            ...stateProps,
            ...ownProps,
            fetchModelConfigs: () => fetchModelConfigs(modelName)
        }
    }
)(ModelDataManager);

export default RXModelDataManager;